/**
 * created on: 2019.04.01
 * 广电广电文稿-广播稿-待编
 */
'use strict';
angular.module('broadcastToBeCompiledModule', [
    'broadcastToBeCompiledRouterModule',
    'broadcastManuscriptModule',
    'broadcastPlannedOrderModule'
])
    .controller('broadcastToBeCompiledCtrl', ['$scope', 'editcenterRightsService', '$q', 'trsHttpService', '$stateParams', '$state', 'broadcastService', 'trsspliceString', 'modalDialog', '$filter', 'editIsLock', '$window', 'trsPrintService', 'storageListenerService', 'editingCenterService', 'editingMediatype',
        function($scope, editcenterRightsService, $q, trsHttpService, $stateParams, $state, broadcastService, trsspliceString, modalDialog, $filter, editIsLock, $window, trsPrintService, storageListenerService, editingCenterService, editingMediatype) {
            initStatus();
            initData();

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    copyCurrPage: 1,
                    doctype: $stateParams.doctype,
                    siteid: $stateParams.siteid,
                    searchTypes: [{
                        name: '全部',
                        value: '',
                    }, {
                        name: '创建人',
                        value: 'CRUSERNAME',
                    }, {
                        name: '标题',
                        value: 'docTitle',
                    }, {
                        name: '正文',
                        value: 'CONTENT',
                    }],
                    selectedType: {
                        name: '全部',
                        value: '',
                    },
                    channelItems: [{
                        name: '全部栏目',
                        value: '',
                    }],
                    selectedChannel: {
                        name: '全部栏目',
                        value: '',
                    },
                    searchWord: '',
                    isESSearch: false,
                    WEBSITE: '',
                    rights: {}
                };
                $scope.data = {
                    items: [],
                    selectedArray: [],
                    editPath: broadcastService.getEditAndPreviewPath().edit,
                    preview: broadcastService.getEditAndPreviewPath().preview,
                    printResult: [],
                    sites: [],
                };
                $scope.page = {
                    PAGESIZE: 50,
                    PAGECOUNT: '',
                    ITEMCOUNT: '',
                    CURRPAGE: 1,
                };
                $scope.params = {};
            }

            /**
             * [initData 初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                if (!$scope.status.siteid) {return;}
                listenStorage();
                initAllChannel().then(function() {
                    getManuscriptData();
                });
            }

            /**
             * [draftRights description] 初始化每项稿件的权限
             * @param  {[type]} item [description] 稿件信息
             * @return {[type]}      [description]
             */
            $scope.draftRights = function(item) {
                if ($scope.status.rights[item.CHNLID]) {
                    item.rights = $scope.status.rights[item.CHNLID];
                } else {
                    $scope.status.rights[item.CHNLID] = {};
                    editcenterRightsService.initTvListBtn('broadcast.daibian', item.CHNLID).then(function(data) {
                        $scope.status.rights[item.CHNLID] = data;
                        item.rights = data;
                    });
                }
            };

            /**
             * [batDisabled description] 批量操作是否有权限
             * @param {String} [operType] [description] 操作类型
             * @return {[type]} [description]
             */
            $scope.batDisabled = function(operType) {
                return $scope.data.selectedArray.some((item, index) => !$scope.status.rights[item.CHNLID][operType]);
            };

            /**
             * [disabledTip description] 批量操作禁止提示语
             * @param {String} [operType] [description] 操作类型
             * @return {[type]} [description]
             */
            $scope.disabledTip = function(operType) {
                for (let i in $scope.data.selectedArray) {
                    let item = $scope.data.selectedArray[i];
                    if (!$scope.status.rights[item.CHNLID][operType]) {
                        return `“${item.CHNLDESC}”栏目下的稿件没有权限`;
                    }
                }
                return '';
            };

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenBroadcast(function() {
                    $scope.status.isESSearch = false;
                    getManuscriptData();
                    storageListenerService.removeListener('broadcast');
                }, $scope);
            }

            /**
             * [initAllChannel 初始化栏目]
             * @return {[type]} [description]
             */
            function initAllChannel() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'getAllChannelsOfDaibian',
                    webSiteId: $scope.status.siteid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    var items = [];
                    if (angular.isArray(data)) {
                        angular.forEach(data, function(obj, index) {
                            items.push({
                                name: obj.CHNLDESC,
                                value: obj.CHANNELID
                            });
                        });
                        $scope.status.channelItems = $scope.status.channelItems.concat(items);
                    }
                    defer.resolve();
                });
                return defer.promise;
            }
            
            /**
             * [getManuscriptData 获取稿件]
             * @return {[type]} [description]
             */
            function getManuscriptData() {
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'queryToBeCompiledDoc',
                    SiteId: $scope.status.siteid,
                    ChannelId: $scope.status.selectedChannel.value,
                    OperTimeStart: $scope.data.fromdate,
                    OperTimeEnd: $scope.data.untildate,
                    DocType: $scope.status.doctype,
                    CurrPage: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE
                };
                $scope.params = $scope.status.isESSearch ? allContentSearch() : params;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                    if (!$scope.status.isESSearch) {
                        $scope.status.searchWord = '';
                    }
                    $scope.data.selectedArray = [];
                    $scope.data.items = data.DATA;
                    $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                    $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                });
            }

            /**
             * [selectAll 全选]
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                if ($scope.data.items.length != $scope.data.selectedArray.length && $scope.data.items.length > 0) {
                    $scope.data.selectedArray = [];
                    for (var i = 0; i < $scope.data.items.length; i++) {
                        $scope.data.selectedArray.push($scope.data.items[i]);
                    }
                } else {
                    $scope.data.selectedArray = [];
                }
            };

            /**
             * [singleSelect 单选]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.singleSelect = function(item) {
                var n = $scope.data.selectedArray.indexOf(item);
                n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
            };

            /**
             * [allContentSearch 全文检索]
             * @return {[type]} [description]
             */
            function allContentSearch() {
                var params = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForBroadcastDoc',
                    searchType: broadcastService.getSearchType().waitcompiled,
                    searchParams: {
                        'PAGESIZE': $scope.page.PAGESIZE,
                        'PAGEINDEX': $scope.page.CURRPAGE,
                        'searchFields': [{
                            'searchField': 'docType',
                            'keywords': $scope.status.doctype
                        },
                        {
                            'searchField': 'channelid',
                            'keywords': $scope.status.selectedChannel.value
                        },
                        {
                            'searchField': 'siteid',
                            'keywords': $scope.status.siteid
                        },
                        {
                            'searchField': 'timeType',
                            'keywords': (angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== '') ? $scope.data.fromdate + ',' + $scope.data.untildate : ''
                        },
                        {
                            'searchField': '_sort',
                            'keywords': 'time'
                        },
                        {
                            'searchField': $scope.status.selectedType.value,
                            'keywords': $scope.status.searchWord,
                        }
                        ]
                    }
                };
                params.searchParams = JSON.stringify(params.searchParams);
                return params;
            }

            /**
             * [searchWord 大数据搜索]
             * @return {[type]} [description]
             */
            $scope.searchWord = function() {
                $scope.status.isESSearch = true;
                getManuscriptData();
            };

            /**
             * [queryByDropdown 快速检索]
             * @return {[type]} [description]
             */
            $scope.queryByDropdown = function() {
                getManuscriptData();
            };

            /**
             * [sendBack 退稿]
             * @return {[type]} [description]
             */
            $scope.sendBack = function() {
                modalDialog.confirmModal('退稿', '确认退稿?', function() {
                    sendBack();
                });
            };

            /**
             * [sendBack 退稿操作]
             * @return {[type]} [description]
             */
            function sendBack() {
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'retreat',
                    MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray,
                        'METADATAID', ',')
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('退稿成功', '', 'success', false, function() {
                        $scope.status.isESSearch = false;
                        $scope.data.selectedArray = [];
                        getManuscriptData();
                    });
                }, function() {
                    $scope.data.selectedArray = [];
                    getManuscriptData();
                });
            }

            /**
             * [sign 签发]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.sign = function(item) {
                $scope.status.isESSearch = false;
                var param = !!item ? item.CHNLDOCID : trsspliceString.spliceString($scope.data.selectedArray,
                    'CHNLDOCID', ',');
                // sensitiveWordCheckService.SensitiveWordsAndCareful($scope.data.selectedArray, "", 2).then(function() {
                //     $scope.status.signedSuccess = true;
                //     directSign(param);
                // }, function() {
                modalDialog.confirmModal('签发', '确认直接签发?', function() {
                    sign(param);
                });
                // });
            };

            /**
             * [sign 签发方法]
             * @param  {[type]} chnldocIDs [description]
             * @return {[type]}            [description]
             */
            function sign(chnldocIDs) {
                var params = {
                    serviceid: 'mlf_broadcast',
                    methodname: 'broadcastDaiBianPublish',
                    ObjectIds: chnldocIDs,
                    ChnlDocIds: chnldocIDs
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(function(data) {
                    modalDialog.alertType('签发成功', '', 'success', false, function() {
                        getManuscriptData();
                        $scope.data.selectedArray = [];
                        // $scope.status.signedSuccess = false;
                    });
                });
            }

            /**
             * [selectedChannelId description]过滤器过滤移动稿件CHANNELID不相同的情况
             * @param  {[type]} elm [description]传入的值
             * @return {[type]}     [description]
             */
            $scope.filterChannelId = function(elm) {
                if (angular.isDefined(elm.CHANNELID)) {
                    return elm.CHANNELID == $scope.data.selectedArray[0].CHANNELID;
                }
            };

            /**
             * [trial description]送审
             * @param  {[type]} item [description] 如果传入代表单个稿件收藏，不传代表批量操作
             * @return {[type]}      [description] null
             */
            $scope.trial = function(item) {
                $scope.status.isESSearch = false;
                var chnlDocIds, metaDataIds;
                if (!!item) {
                    chnlDocIds = item.CHNLDOCID;
                    metaDataIds = item.METADATAID;
                } else {
                    chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                    metaDataIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                }
                trial(chnlDocIds, metaDataIds);
            };

            /**
             * [trial 送审方法]
             * @param  {[type]} chnlDocIds  [description]
             * @param  {[type]} metaDataIds [description]
             * @return {[type]}             [description]
             */
            function trial(chnlDocIds, metaDataIds) {
                var temp = $filter('pick')($scope.data.selectedArray, $scope.filterChannelId);
                if (temp.length === $scope.data.selectedArray.length) {
                    modalDialog.inputModel('送审', '送审意见（选填）', function(content) {
                        var params = {
                            'serviceid': 'mlf_broadcast',
                            'methodname': 'trialMetaDatas',
                            'MetaDataIds': metaDataIds,
                            'ChnlDocIds': chnlDocIds,
                            'Opinion': content,
                            'CurrChnlId': $scope.data.selectedArray[0].CHANNELID,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                            .then(function(data) {
                                modalDialog.alertType('送审成功', '', 'success', false);
                                $scope.data.selectedArray = [];
                                getManuscriptData();
                            }, function() {getManuscriptData();});
                    });
                } else {
                    modalDialog.alertType('稿件送审失败', '所选稿件不属于同一栏目', 'error', 'confirm');
                }
            }

            /**
             * [isLockEdit description:编辑前请求解锁]
             * @param  {[type]} item [description:稿件对象]
             */
            $scope.isLockEdit = function(item) {
                $scope.status.isESSearch = false;
                editIsLock.isLock(item, 16).then(function(data) {
                    var editPath = $scope.data.editPath[item.DOCTYPEID];
                    var editParams = {
                        broadcastchannelid: item.CHANNELID,
                        broadcastchnldocid: item.CHNLDOCID,
                        broadcastmetadataid: item.METADATAID,
                        broadcastsiteid: $stateParams.siteid,
                        broadcastplatform: 0
                    };
                    var editUrl = $state.href(editPath, editParams);
                    if (data.ISLOCK == 'false') {
                        $window.open(editUrl);
                    } else {
                        editIsLock.checkUnlockPermissions(item, data).then(function() {
                            $window.open(editUrl);
                        });

                        /* modalDialog.alertType("稿件已经被【" + data.LOCKUSER + "】锁定,是否强制解锁", "", "warning", true, function() {
                            editIsLock.forceDeblocking(item).then(function(data) {
                                $window.open(editUrl);
                            });
                        }, function() {});*/
                    }
                });
            };

            /**
             * [printBtn 打印]
             * @return {[type]} [description]
             */
            $scope.printBtn = function() {
                $scope.status.isESSearch = false;
                // if (checkDraftType($scope.status.draftType.subject)) {
                //     modalDialog.alertType("所选稿件中有专题稿，无法打印", '', "error", false);
                //     return;
                // }
                angular.forEach($scope.data.selectedArray, function(value, key) {
                    if ($scope.status.doctype == 9) {
                        requestPrintData(value);
                    } else {
                        getStationName().then(function(data) {
                            requestPrintData(value);
                        });
                    }
                });
            };

            /**
             * [getStationName 获取站点名称-用于打印操作]
             * @return {[type]} [description]
             */
            function getStationName() {
                var defer = $q.defer();
                initTvStation().then(function() {
                    if ($scope.status.WEBSITE != '') {
                        defer.resolve();
                    } else {
                        for (var i in $scope.data.sites) {
                            if ($scope.data.sites[i].SITEID == $scope.status.siteid) {
                                $scope.status.WEBSITE = $scope.data.sites[i];
                                break;
                            }
                        }
                        defer.resolve();
                    }
                });
                return defer.promise;
            }

            /**
             * [initTvStation 初始化电视站点]
             * @return {[type]} [description]
             */
            function initTvStation() {
                var defer = $q.defer();
                editingCenterService.querySitesByMediaType(editingMediatype.broadcast).then(function(data) {
                    if (angular.isUndefined(data)) {
                        defer.reject();
                    } else {
                        $scope.data.sites = data.DATA;
                        defer.resolve();
                    }
                });
                return defer.promise;
            }

            // /**
            //  * [requestPrintVersion 打印流程请求]
            //  * @param  {[type]} item [description]
            //  * @return {[type]}      [description]
            //  */
            // function requestPrintVersion(item) {
            //     var defer = $q.defer();
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
            //         serviceid: "mlf_metadatalog",
            //         methodname: "query",
            //         MetaDataId: item.METADATAID
            //     }, 'get').then(function(data) {
            //         defer.resolve(data.DATA);
            //     });
            //     return defer.promise;
            // }

            /**
             * [requestPrintData 打印请求详情]
             * @param  {[type]} item    [description]
             * @param  {[type]} version [description]
             * @return {[type]}         [description]
             */
            function requestPrintData(item) {
                var params;
                if ($scope.status.doctype == 9) {
                    params = {
                        'serviceid': 'mlf_broadcast',
                        'methodname': 'getWenGaoDoc',
                        'MetaDataId': item.METADATAID
                    };
                } else {
                    params = {
                        'serviceid': 'mlf_broadcast',
                        'methodname': 'queryQuoteDocLists',
                        'SeriesDocId': item.METADATAID
                    };
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if ($scope.status.doctype == 9) {
                        var result = data;
                        // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                        $scope.data.printResult.push(result);
                        if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                            trsPrintService.trsTvPrintDocument($scope.data.printResult);
                            $scope.data.printResult = [];
                        }
                    } else {
                        item.ITEMS = data;
                        item.WEBSITE = $scope.status.WEBSITE;
                        $scope.data.printResult.push(item);
                        if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                            trsPrintService.trsTvPrintDocument($scope.data.printResult);
                            $scope.data.printResult = [];
                        }
                    }
                });
            }

            /**
             * [export 导出稿件]
             * @return {[type]} [description]
             */
            $scope.export = function() {
                $scope.status.isESSearch = false;
                var params = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportWordFile',
                    MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                    $scope.data.selectedArray = [];
                }, function(data) {
                    if (data.REPORTS[0].ISSUCCESS == 'true') {
                        window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                        $scope.data.selectedArray = [];
                    }
                });
            };

            /**
             * [televisionPreview 数据存储到storage]
             * @return {[type]} [description]
             */
            $scope.televisionPreview = function(item, type) {
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID,DOCTYPEID,CHANNELID', type);
            };

            /**
             * [showVersionTime description]展示流程版本与操作日志
             * @param  {[str]} MetaDataId [description]
             * @return {[type]}            [description]
             */
            $scope.showVersionTime = function(item) {
                editingCenterService.getVersionTime(item, false);
            };

            $scope.selectPageNum = function() {
                getManuscriptData();
            };

            $scope.pageChanged = function() {
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                getManuscriptData();
            };

            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                } else if ($scope.status.copyCurrPage === '' || $scope.status.copyCurrPage === 0 || $scope.status.copyCurrPage < 0 || isNaN(Number($scope.status.copyCurrPage))) {
                    $scope.status.copyCurrPage = 1;
                }
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                getManuscriptData();
            };
        }
    ])
;
